import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { showModal } from 'actions/response';
import { setMetricsEvent } from 'action-creators/metrics';
import {
  onActiveControlPin,
  onChangeControlPin,
  onDesactiveControlPin,
  onModifyControlPin,
  onRemindControlPin,
  onSetControlPin,
  onStatusControlPin,
} from 'action-creators/user/controlPin';
import {
  getLoading,
  getInitial,
  getIsSuccess,
  getStatusIsActive,
  getStatusPinValues,
  getControlPinError,
} from 'selectors/user/controlPin/';
import Metrics from 'services/metrics';

import {
  getLabels,
  ACTIVE,
  CHANGE,
  DEFAULT,
  DESACTIVE,
  MODIFY,
  NOT_ACTIVE,
  REMIND,
  SET_PIN,
} from './constants';
import { hasErrors, getPropsModalSuccess, getPropsModalError } from './utils';
import ControlPin from './controlPin';
import { useSearchParams } from 'react-router-dom';
import { getQueryParamsObject } from './../../../utils/getQueryParamsObject'

function ControlPinSection({
  location,
  user,
  loaded,
  initial,
  isSuccess,
  errorPIN,
  isActivePIN,
  valueStatus,
  onMetrics,
  handleShowModal,
  handleActiveControlPin,
  handleChangeControlPin,
  handleDesactiveControlPin,
  handleModifyControlPin,
  handleRemindControlPin,
  handleSetControlPin,
  handleStatusControlPin,
  translations
}) {
  const [searchParams] = useSearchParams()
  const labels = getLabels(translations);
  const [form, setForm] = useState({});
  const [infoPin, setInfoPin] = useState({ ...valueStatus });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [typeForm, setTypeForm] = useState('');

  useEffect(() => {
    const activePin = activePinByURL();
    if (activePin) {
      handleSetControlPin(activePin);
    } else {
      handleStatusControlPin();
    }
    return () => console.log('unmount MyAccount');
  }, []);

  useEffect(
    () => {
      setLoading(loaded);
      if (isSuccess) onSuccess(typeForm);
      if (initial) {
        setInfoPin(valueStatus);
        if (typeForm === '') {
          const type = isActivePIN ? DEFAULT : NOT_ACTIVE;
          setTypeForm(type);
        }
      }
      if (errorPIN) {
        onFail(errorPIN, typeForm);
      }
    },
    [initial, loaded, isSuccess, errorPIN],
  );

  const onSuccess = e => {
    const type = e === '' && activePinByURL() ? SET_PIN : e;
    if (type !== DEFAULT && type !== NOT_ACTIVE) {
      const props = getPropsModalSuccess(type, translations);
      handleShowModal({ ...props });
      setLoading(false);
      handleCancel();
      if (type === SET_PIN) {
        setTypeForm(DEFAULT);
        handleStatusControlPin();
      }
    }
  };

  const onFail = (data, type) => {
    const typeInfo = type === '' && activePinByURL() ? SET_PIN : type;
    if (typeInfo !== DEFAULT && typeInfo !== NOT_ACTIVE) {
      const props = getPropsModalError(typeInfo, data, translations);
      handleShowModal({ ...props });
      setLoading(false);
    }
  };

  const activePinByURL = () => {
    const  query  = getQueryParamsObject(searchParams);
    if (query.pin_parental || query.pin_purchase) {
      const params = {};
      const pinCode = get(query, 'pin_code', get(query, 'pin'), false);
      if (pinCode) params.pin_code = pinCode;

      const userHash = get(query, 'user_hash', user.userhash);
      if (userHash) params.user_hash = userHash;

      const pinRating = get(
        query,
        'pin_ratings',
        get(query, 'clasificacion'),
        false,
      );
      if (pinRating) params.pin_ratings = pinRating;

      params.pin_channel = get(query, 'pin_channel', 0);
      params.pin_parental = get(query, 'pin_parental', 0);
      params.pin_purchase = get(query, 'pin_purchase', 0);
      return params;
    }
    return false;
  };

  const handleToggle = e => {
    let params = {};
    let label = '';
    if (e === MODIFY) {
      params = {
        pin_parental: infoPin.pinParental,
        pin_purchase: infoPin.pinPurchase,
        pin_ratings: infoPin.pinParentalInfo && infoPin.pinParentalInfo.value,
      };
    }
    if (e === ACTIVE) {
      label = 'Activar';
    }
    if (e === NOT_ACTIVE) {
      label = 'Cancelar';
    }
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Pin Parental',
      eventLabel: label,
    });
    setLoading(false);
    setErrors({});
    setForm({ ...params });
    setTypeForm(e);
  };

  const handleCancel = () => {
    setLoading(false);
    setErrors({});
    setForm({});
    const type = isActivePIN ? DEFAULT : NOT_ACTIVE;
    setTypeForm(type);
  };

  const handleChange = ({ target }) => {
    const { name, type } = target;
    const value = type === 'checkbox' ? target.checked : target.value;
    const data = {};
    let label = 'Protección de pagos';
    if (name === 'pin_parental') {
      data.pin_ratings = 20;
      label = 'Control Parental';
    }

    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Pin Parental',
      eventLabel: `${label} - ${target.checked ? 'Activar' : 'Desactivar'}`,
    });
    setForm({ ...form, ...data, [name]: value });
  };

  const handleSave = e => {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Pin Parental',
      eventLabel: 'Confirmar',
    });
    if (e === ACTIVE) {
      const hasError = hasErrors(e, form, translations);
      if (hasError) setErrors(hasError);
      else {
        const { userhash } = user;
        const data = { ...form, user_hash: userhash };
        if (form.pin_parental) data.pin_parental = 1;
        if (form.pin_purchase) data.pin_purchase = 1;
        handleActiveControlPin({ userhash }, data);
      }
    }
    if (e === CHANGE) {
      const hasError = hasErrors(e, form,translations);
      if (hasError) setErrors(hasError);
      else handleChangeControlPin(form);
    }
    if (e === DESACTIVE) {
      const data = {
        status_purchase_pin: 0,
        status_parental_pin: 0,
        status_channel_pin: 0,
        accesss_parental_code: 20,
        ...form,
      };
      const hasError = hasErrors(e, form,translations);
      if (hasError) setErrors(hasError);
      else handleDesactiveControlPin(data);
    }
    if (e === MODIFY) {
      const hasError = hasErrors(e, form,translations);
      if (hasError) setErrors(hasError);
      else {
        const { user_id: userId } = user;
        const data1 = { controlPIN: form.pin_code, userId };

        const data2 = {
          status_parental_pin: form.pin_parental ? 1 : 0,
          status_purchase_pin: form.pin_purchase ? 1 : 0,
          accesss_parental_code: form.pin_ratings,
          pin: form.pin_code,
          status_channel_pin: infoPin.pinChannel || 0,
        };
        handleModifyControlPin(data1, data2);
      }
    }
    if (e === REMIND) {
      const { userhash } = user;
      const data = { ...form, user_hash: userhash };
      handleRemindControlPin(data);
    }
  };

  const handleSendMetrics = () => {
    const tagManager = {
      event: 'Pin',
      gaEventCategory: 'Pin',
      gaEventAction: 'Click',
      gaEventLabel: 'Activar',
      gaEventNonInteraction: '1',
    };
    onMetrics({ tagManager });
    onMetrics({ type: 'executor', success: true });
  };
  return (
    <ControlPin
      errors={errors}
      infoPin={infoPin}
      isActive={isActivePIN}
      typeForm={typeForm}
      label={labels}
      loading={loading}
      onSendMetrics={handleSendMetrics}
      onToggle={handleToggle}
      onChange={handleChange}
      onSave={handleSave}
      form={form}
    />
  );
}

ControlPinSection.propTypes = {
  user: PropTypes.object,
  loaded: PropTypes.bool,
  isSuccess: PropTypes.bool,
  initial: PropTypes.bool,
  valueStatus: PropTypes.object,
  isActivePIN: PropTypes.bool,
  errorPIN: PropTypes.bool,
  onMetrics: PropTypes.func.isRequired,
  handleShowModal: PropTypes.func.isRequired,
  handleActiveControlPin: PropTypes.func.isRequired,
  handleChangeControlPin: PropTypes.func.isRequired,
  handleDesactiveControlPin: PropTypes.func.isRequired,
  handleModifyControlPin: PropTypes.func.isRequired,
  handleRemindControlPin: PropTypes.func.isRequired,
  handleSetControlPin: PropTypes.func.isRequired,
  handleStatusControlPin: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
  loaded: getLoading(state),
  isSuccess: getIsSuccess(state),
  initial: getInitial(state),
  isActivePIN: getStatusIsActive(state),
  valueStatus: getStatusPinValues(state),
  errorPIN: getControlPinError(state),
  translations: state?.translations
});

const mapDispatchToProps = dispatch => ({
  handleShowModal(payload) {
    dispatch(showModal(payload));
  },
  onMetrics(options) {
    dispatch(setMetricsEvent(options));
  },
  handleActiveControlPin(emailParams, activeParams) {
    dispatch(onActiveControlPin(emailParams, activeParams));
  },
  handleChangeControlPin(payload) {
    dispatch(onChangeControlPin(payload));
  },
  handleDesactiveControlPin(payload) {
    dispatch(onDesactiveControlPin(payload));
  },
  handleModifyControlPin(checkParams, modifyParams) {
    dispatch(onModifyControlPin(checkParams, modifyParams));
  },
  handleRemindControlPin(payload) {
    dispatch(onRemindControlPin(payload));
  },
  handleSetControlPin(payload) {
    dispatch(onSetControlPin(payload));
  },
  handleStatusControlPin(payload) {
    dispatch(onStatusControlPin(payload));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ControlPinSection);
